export const transitionTimeMilliseconds = 200
export const transitionAnimationTime = `${transitionTimeMilliseconds / 1000}s`
export const transitionAnimationType = 'linear'
